module.exports = __webpack_public_path__ + "img/picture_viptk04.a1062024.png";